export type StudentTenureFilter = 'all' | 'new' | 'established';

export const DEFAULT_STUDENT_TENURE_FILTER: StudentTenureFilter = 'all';

export const STUDENT_TENURE_FILTER_OPTIONS = [
  { value: 'all' as const, label: 'Todas' },
  { value: 'new' as const, label: 'Novas', hint: '-1 mês de consultoria' },
  { value: 'established' as const, label: 'Antigas', hint: '+1 mês consultoria' },
];
